import { lazy } from "react";

/**
 * Landing pages publicitaires (Google Ads).
 * - Layout autonome : aucun menu, aucune navigation interne (hors mentions légales).
 * - noindex via useSEO : jamais indexées, donc aucun risque de cannibalisation
 *   avec les pages SEO équivalentes (/demenagement-paris-75, etc.).
 * - À ne JAMAIS ajouter dans public/sitemap.xml.
 */

const LpDemenagementParis = lazy(() => import("@/pages/LpDemenagementParis"));
const LpDevisParis = lazy(() => import("@/pages/LpDevisParis"));

export const LANDING_ROUTES = [
  { path: "/lp/devis-paris", Component: LpDemenagementParis },
  { path: "/lp/devis-paris/formulaire", Component: LpDevisParis },
];
